import styles from './slider.module.scss';
import MaterialSlider from '@mui/material/Slider';

/* eslint-disable-next-line */
export interface SliderProps {
  // ariaLabel?: string,
  // ariaLabelledby?: string,
  // ariaValuetext?: string,
  // classes?: object,
  // color?:
  // 'primary'
  // | 'secondary',
  // component?: any,
  // components?: { Mark?: any, MarkLabel?: any, Rail?: any, Root?: any, Thumb?: any, Track?: any, ValueLabel?: any },
  // componentsProps?: object,
  defaultValue?: Array<number> | number;
  // disabled?: boolean,
  // disableSwap?: boolean,
  // getAriaLabel?: (index: number) => string,
  // getAriaValueText?: (value: number, index: number) => string,
  // isRtl?: boolean,
  // marks?: Array<{ label?: ReactNode, value: number }> | boolean,
  // max?: number,
  // min?: number,
  // name?: string,
  onChange?: (event: Event, value: number | Array<number>, activeThumb: number) => void;
  // onChangeCommitted?: (event: any | Event, value: number | Array<number>) => void,
  // orientation?:'horizontal'| 'vertical',
  // scale?: any,
  size?: 'small' | 'medium';
  // step?: number,
  // sx?: any,
  // tabIndex?: number,
  // track?: 'inverted' | 'normal' | false,
  value?: Array<number> | number;
  valueLabelDisplay?: 'auto' | 'off' | 'on';
  // valueLabelFormat?: any
}

export function Slider(props: SliderProps) {
  return (
    <MaterialSlider
      value={props.value}
      onChange={props.onChange}
      size={props.size}
      defaultValue={props.defaultValue}
      valueLabelDisplay={props.valueLabelDisplay}
    />
  );
}

export default Slider;